<template>
  <div class="templates-bounding">
    <div class="templates-header">
      <div class="header-container">
        <h1 class="templates-title-text">{{ this.$t("formview.MyTemplates") }}</h1>
        <button class="templates-exit-button" @click="close">X</button>
      </div>
    </div>

    <div class="tab-box">
      <TabsComponent :tabs="[this.$t(`formview.Forms`), this.$t(`formview.Coords`)]" @tab-selected="setActiveTab" />

    </div>


    <div class="templates-main-section">
      
      <div class="templates-content">
        <div class="templates-tabs-content">
          <div class="templates-tab-content">
            
            <div v-if="filteredTemplates.length == 0" class="error-message">
              {{$t("formview.NoTemplatesFound")}}
            </div>
            <div v-else>
              <div
                v-for="template in filteredTemplates" 
                :key="template.name"
                @click="applyTemplate(template)"
                @mouseenter="onMouseEnter(template, $event)"
                @mouseleave="onMouseLeave"
                class="statistic template"
              >
                <span class="stat-name">{{ template.name }}</span>

                <div class="additionalInfo" v-if="hoveredTemplate === template">
                  <div v-if="!template.values[0].category">
                    {{ $t('formview.ManualTemplate')}}
                  </div>
                  <div v-else>
                    <div v-for="(value, key) in template.values" :key="key">
                      {{ $t('formview.' + value.category) }}: {{ value.input_value }}
                    </div>
                  </div>
                </div>

                <div class="stat-value">
                  <img src="@/assets/images/button_delete_template.svg" alt="delete" @click.stop="removeTemplate(template)">
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import TabsComponent from './TabsComponent.vue';

export default {
  name: 'templateModal',
  data() {
    return {
      loadingError: this.$t("formview.NoTemplatesFound"),
      activeTab: 0,
      hoveredTemplate: null,
    };
  },
  props: {
    templates: Array,
  },
  emits: ['close','apply-manual-template','apply-template','remove-template'],
  components: {
    TabsComponent,
  },
  computed: {
    filteredTemplates() {
      console.log(this.activeTab)
      // Filter templates based on active tab
      return this.templates.filter(template => {
        const firstValue = template.values?.[0];

        if (this.activeTab === 0) {
          // Tab 0: only templates with a value[0] AND no rect
          return firstValue && firstValue.rect === undefined;
        } else if (this.activeTab === 1) {
          // Tab 1: templates that either:
          // 1. have a value[0] AND it has a rect
          // 2. have no value[0] at all
          return !firstValue || firstValue.rect !== undefined;
        } else {
          return false;
        }
      });
    }
  },
  methods: {

    setActiveTab(tabIndex) {
      this.activeTab = tabIndex;
    },

    close() {
      this.$emit('close');
    },
    applyTemplate(template) {
      this.close();
      if (template.values[0].rect !== undefined){
        this.$emit('apply-manual-template', template);
      }
      else{
        this.$emit('apply-template', template);
    }
    },
    removeTemplate(template) {
      this.$emit('remove-template', template);
    },
    onMouseEnter(template, event) {
      this.hoveredTemplate = template;
      this.positionAdditionalInfo(event.target.closest('.statistic'));
    },
    onMouseLeave() {
      this.hoveredTemplate = null;
    },
    positionAdditionalInfo(hoveredElement) {
      this.$nextTick(() => {
        const infoBox = this.$el.querySelector('.additionalInfo');
        if (infoBox) {
          console.log(infoBox)
          const viewportWidth = window.innerWidth;
          const boxWidth = infoBox.offsetWidth;
          const rect = hoveredElement.getBoundingClientRect();
          infoBox.style.top = `${rect.bottom + window.scrollY}px`;
          infoBox.style.left = `${(viewportWidth / 2) - (boxWidth / 2) + window.scrollX}px`;
          infoBox.style.display = 'block';
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped src="@/assets/css/components/TemplateModal.scss" />

